import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex space-x-2 items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "flex-grow rounded-md shadow-lg focus:bg-gray-600 bg-backgroundGrey h-10 px-4 py-4 text-sm leading-5 font-medium text-white focus:outline-none active:bg-gray-600 transition ease-in-out duration-150 btn-focus",
      placeholder: "Suche",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textLocal) = $event)),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args)), ["enter"]))
    }, null, 544), [
      [_vModelText, _ctx.textLocal]
    ]),
    (!_ctx.activateOnChange)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "flex-none rounded-md shadow-lg bg-gray-600 p-2 active:bg-backgroundGrey focus:ring-0 focus:outline-none",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerText && _ctx.triggerText(...args)))
        }, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}